module.exports = __webpack_public_path__ + "static/63-c9ed93bb3438a50d82cb9bbba843d3ff.png";